export default __webpack_public_path__ + "static/media/list-close_icon_light.86a80af9.svg";